import type {ModalSystemProps} from "@/global/providers/ModalProvider";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";
import {type ChangeEvent, useCallback, useState} from "react";
import type {SchoolChangeCashbackDto} from "@/global/api/gen/ts/SchoolChangeCashbackDto";
import type {SchoolWithUserDto} from "@/global/api/gen/ts/SchoolWithUserDto";
import {apiChangeCashback} from "@/modules/schools/services/school.service";
import {toast} from "react-toastify";
import {LoadingButton} from "@mui/lab";

interface Props {
    schoolInfo: SchoolWithUserDto;
}

export function SchoolCashbackModal({open, close, schoolInfo}: ModalSystemProps<Props>) {
    const [cashback, setCashback] = useState<SchoolChangeCashbackDto>(schoolInfo.cashback ?? {});

    const {mutate, isPending} = apiChangeCashback();

    const handleChangeCashback = () => {
        mutate({...cashback, schoolId: schoolInfo.id},  {
            onSuccess: () => {
                close(0);
                toast.success('Кешбек успешно изменен');
            },
        });
    };

    const onChangeCashback = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        const name = event.target.name as keyof SchoolChangeCashbackDto;
        const value = +(event.target.value);
        setCashback((prevState) => {
            return {
                ...prevState,
                [name]: isNaN(value) ? null : value
            };
        });
    }, []);

    return (
        <Dialog
            open={open}
            onClose={() => close(0)}
        >
            <DialogTitle>
                Изменение кешбека
            </DialogTitle>
            <DialogContent>
                <TextField
                    label="Кешбек AiTest"
                    name="aitestPercent"
                    type="number"
                    value={cashback.aitestPercent ?? ''}
                    onChange={onChangeCashback}
                    fullWidth
                    margin="normal"
                />
                <TextField
                    label="Кешбек за сертификаты"
                    name="certificatePercent"
                    type="number"
                    value={cashback.certificatePercent ?? ''}
                    onChange={onChangeCashback}
                    fullWidth
                    margin="normal"
                />
                <DialogActions>
                    <Button
                        onClick={() => close(0)}
                    >
                        Отмена
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        onClick={handleChangeCashback}
                        loading={isPending}
                    >
                        Изменить
                    </LoadingButton>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}